import { useTranslations } from "use-intl";
import { Result } from "@/shared/feedback/result";

export function RejectedResult() {
  const t = useTranslations("ExternalSign");

  // Result из antd чужие атрибуты в разметку не пропускает — метка стоит на обёртке.
  return (
    <div data-testid={"external-sign-rejected"}>
      <Result
        status="warning"
        title={t("Document rejected")}
        subTitle={t("Document rejected hint")}
      />
    </div>
  );
}
